(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Queue_scheduledDialogController', Queue_scheduledDialogController);

    Queue_scheduledDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Queue_scheduled', 'Qsched_direction', 'Qsched_status', 'Qsched_type'];

    function Queue_scheduledDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Queue_scheduled, Qsched_direction, Qsched_status, Qsched_type) {
        var vm = this;

        vm.queue_scheduled = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.qsched_directions = Qsched_direction.query();
        vm.qsched_statuses = Qsched_status.query();
        vm.qsched_types = Qsched_type.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queue_scheduled.id !== null) {
                Queue_scheduled.update(vm.queue_scheduled, onSaveSuccess, onSaveError);
            } else {
                Queue_scheduled.save(vm.queue_scheduled, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queue_scheduledUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dt_ins = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
